<script setup lang="ts">
import type { DateRange, DateValue } from 'reka-ui';
import type { WeekStartsOn } from './week';
import { RangeCalendarRoot } from 'reka-ui';
import { formatWeekDays } from './week';

defineProps<{
  layout: 'mobile' | 'desktop';
  locale: string;
  weekStartsOn: WeekStartsOn;
  minValue?: DateValue;
  maxValue?: DateValue;
  placeholder?: DateValue;
  numberOfMonths?: number;
  ghostEnd?: DateValue;
  crescentStart?: boolean;
  directFlightDates?: string[];
}>();

const model = defineModel<DateRange>();
</script>

<template>
  <RangeCalendarRoot
    v-model="model"
    :default-placeholder="placeholder"
    :number-of-months="numberOfMonths ?? (layout === 'mobile' ? 12 : 2)"
    :min-value="minValue"
    :max-value="maxValue"
    :locale="locale"
    weekday-format="short"
    :week-starts-on="weekStartsOn"
    disable-days-outside-current-view
  >
    <template #default="{ grid, weekDays }">
      <div :class="layout === 'mobile' ? 'group flex flex-col gap-3' : 'group flex gap-6'">
        <UiCustomRangeCalendarGrid
          v-for="(month, i) in grid"
          :key="month.value.toString()"
          :month="month"
          :week-days="formatWeekDays(weekDays)"
          :vertical="layout === 'mobile'"
          :hide-nav="layout === 'mobile'"
          :is-first="layout === 'desktop' && i === 0"
          :is-last="layout === 'desktop' && i === grid.length - 1"
          :ghost-end="ghostEnd"
          :crescent-start="crescentStart"
          :direct-flight-dates="directFlightDates"
        />
      </div>
    </template>
  </RangeCalendarRoot>
</template>
